import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/services/firebase/config'
import { DEFAULT_FEATURE_FLAGS, type FeatureFlags } from '@/types/featureFlags'

const FEATURES_DOC_PATH = ['settings', 'features'] as const

/**
 * Fetch the admin-managed platform feature flags.
 * Returns DEFAULT_FEATURE_FLAGS when the doc doesn't exist yet, so callers
 * never have to null-check. Defaults are feature-OFF (fail-safe).
 */
export async function getFeatureFlags(): Promise<FeatureFlags> {
  const snapshot = await getDoc(doc(db, ...FEATURES_DOC_PATH))
  if (!snapshot.exists()) return DEFAULT_FEATURE_FLAGS
  const data = snapshot.data() as Partial<FeatureFlags>
  return { ...DEFAULT_FEATURE_FLAGS, ...data }
}

/**
 * Save the admin-managed platform feature flags.
 * Admin-only — enforced by Firestore rules on the `settings/` collection.
 */
export async function saveFeatureFlags(flags: FeatureFlags): Promise<void> {
  await setDoc(
    doc(db, ...FEATURES_DOC_PATH),
    { ...flags, updatedAt: serverTimestamp() },
    { merge: true },
  )
}
